import { useState, useEffect, useCallback } from "react";
import { rankingsApi } from "../api";
import { RankingUser } from "../types";

interface RankingsState {
  rankings: RankingUser[];
  isLoading: boolean;
  error: string | null;
}

// 月次ポイント推移データを生成する関数
const generateMonthlyPoints = (
  eventAcquiredPoints: Array<{ event_name: string; point: number; date: string }>
) => {
  // 月ごとのポイントを集計
  const monthlyMap = new Map<string, number>();
  
  eventAcquiredPoints.forEach((item) => {
    // dateをYYYY-MM形式でパース
    const date = new Date(item.date);
    const month = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
    
    const current = monthlyMap.get(month) || 0;
    monthlyMap.set(month, current + item.point);
  });

  // ソートして配列に変換
  const months = Array.from(monthlyMap.entries())
    .sort(([monthA], [monthB]) => monthA.localeCompare(monthB))
    .map(([month, points]) => ({
      month,
      points,
    }));

  return months;
};

export const useRankings = () => {
  const [state, setState] = useState<RankingsState>({
    rankings: [],
    isLoading: true,
    error: null,
  });

  const fetchAll = useCallback(async () => {
    setState((s) => ({ ...s, isLoading: true, error: null }));

    try {
      const yearlyRankingResponse = await rankingsApi.getYearly();
      const rankings = yearlyRankingResponse.rankings.map((r) => ({
        rank: r.rank,
        name: r.name,
        points: r.point,
        isMe: r.is_login_member,
        monthlyPoints: generateMonthlyPoints(r.event_acquired_points),
        eventAcquiredPoints: r.event_acquired_points,
      }));
      setState({ rankings, isLoading: false, error: null });
    } catch {
      setState((s) => ({
        ...s,
        isLoading: false,
        error: "ランキングの取得に失敗しました",
      }));
    }
  }, []);

  useEffect(() => {
    fetchAll();
  }, [fetchAll]);

  return { ...state, fetchAll };
};
